import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Inline validation / error text for a form control.
 *
 * @component
 * @selector app-error-message
 * @example
 *   <app-error-message testId="login-email-error-message">
 *     Please enter a valid email address.
 *   </app-error-message>
 *
 * @input {string} testId - `data-testid` for the message container, so automation can assert the
 *   error independently of its wording. Defaults to the generic `error-message`; consumers that
 *   render more than one must pass a control-scoped value (e.g. `login-password-error-message`).
 */
@Component({
  selector: 'app-error-message',
  imports: [],
  templateUrl: './error-message.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error-message.component.scss',
})
export class ErrorMessageComponent {
  @Input() testId = 'error-message';
}
